<script>
	// Stores
	import MarketStore from '@/Stores/Sport/MarketStore.js';
	// Components
	import Switch from '@/Components/Switch.svelte';
	// Services
	import { notify } from '@/Services/Notify.js';

	export let market;

	let multisEnabled = market && market.multis;

	function updateMultis() {
		MarketStore.updateMarketMultis(market.id, multisEnabled)
			.then(() => {
				notify({
					type: 'success',
					title: `${market.name}`,
					message: `Multis for Market updated to ${multisEnabled ? 'On' : 'Off'}`,
					timeout: 3
				});
			})
			.catch(() => {
				multisEnabled = !multisEnabled;
				notify({
					type: 'danger',
					title: `${market.name}`,
					message: 'Failed to update Multis',
					timeout: 3
				});
			});
	}
</script>

<div class="flex items-center justify-between">
	<div class="text-xs font-semibold uppercase">Multis</div>
	<Switch
		on:change={updateMultis}
		name={`enable-market-multis-${market.id}`}
		bind:checked={multisEnabled}
		small={true}
		className=""
	/>
</div>
